var cilAirplay = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M464,47H48A32.036,32.036,0,0,0,16,79V376a32.036,32.036,0,0,0,32,32h76.448l24.89-32H48V79H464l.02,297H362.662l24.89,32H464a32.036,32.036,0,0,0,32-32V79A32.036,32.036,0,0,0,464,47Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M98.834,496H413.166L256,293.939Zm65.431-32L256,346.061,347.735,464Z' class='ci-primary'/>"];

export { cilAirplay };

